import { connect } from "react-redux";
import Layout from "../components/Layout";
// import { getCurrentUser } from "../redux/actions/surveyActions";
import {
	authGetCurrentUserInfos,
	authLogout,
	setCurrentClient,
	changeLanguage,
} from "./../redux/actions/authActions";

const mapStateToProps = (state, ownProps) => {
	return {
		// currentUser: state.survey.surveyManager.currentUser,
		userInfos: state.userInfos,
		currentClient: state.currentClient,
		language: state.intl.locale,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		// getCurrentUser: currentUser => {
		// 	dispatch(getCurrentUser(currentUser));
		// },
		authGetCurrentUserInfos: () => dispatch(authGetCurrentUserInfos()),
		authLogout: () => {
			dispatch(authLogout())},
		setCurrentClient: clientInfos => dispatch(setCurrentClient(clientInfos)),
		changeLanguage: language => {
			dispatch(changeLanguage(language));
			localStorage.setItem("language", language);
			window.location.reload();
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Layout);



// WEBPACK FOOTER //
// src/containers/LayoutContainer.js